import React, { useEffect, useRef, useState } from "react";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  unachivedAccount,
  achivedAccount,
  beneLookUp,
  viewAccountDetail,
  resetAchivedAccount,
  resetUnAchivedAccount,
} from "../../redux/features/verifyPAN/verifyPAN";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import { beneBankLookUp } from "../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { checkUsertoken } from "../../redux/features/login/login";
import RefreshToast from "../_utils/RefreshToast";

const BeneficiaryModal = ({
  close,
  id,
  type,
  setAccountType,
  message,
  panNumber,
  setIsArchived,
  setShutViewAll,
  setBankAccountType,
  setBankIsArchived,
  setBankShutViewAll,
  payload,
  createFlow,
  setShowAction,
  title,
  note,
  bankAccountType,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const modalRef = useRef(null);
  const [isAchived, setIsArchivedCurrent] = useState(false);
  const [bankIsAchived, setBankIsArchivedCurrent] = useState(false);
  const [isUnAchived, setIsUnArchived] = useState(false);
  const [bankIsUnAchived, setBankIsUnArchived] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [isMobileView1, setIsMobileView1] = useState(window.innerWidth <= 400);
  const { unachivedLoading, achivedLoading, unachivedData, achivedData } =
    useSelector((state) => state.verify);

  const handlebank = async () => {
    if (type === "unarchived") {
      RefreshToast("unarchive");
      dispatch(checkUsertoken());
      await dispatch(unachivedAccount({ id }));
      setBankIsArchived(false);
    } else if (type === "archived") {
      RefreshToast("archive");
      dispatch(checkUsertoken());
      await dispatch(achivedAccount({ id }));
    }
    setBankShutViewAll(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView1(window.innerWidth <= 400);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  const handlePan = async () => {
    if (type === "unarchived") {
      dispatch(checkUsertoken());
      dispatch(unachivedAccount({ id }));
      navigate(`/accounts/beneficiary_account/details/${id}`);
      setIsArchived(false);
    } else if (type === "archived") {
      dispatch(checkUsertoken());
      dispatch(achivedAccount({ id }));
    }
    setShutViewAll(false);
  };

  const displayToastError = (errorObject) => {
    if (errorObject?.user_unauthorized?.length > 0) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "BAAccountArchive",
        },
      });
      return;
    }
    if (errorObject) {
      const errorMessages = Object.values(errorObject).flat();
      if (errorMessages.length > 0) {
        toast.error(errorMessages[0], {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };

  useEffect(() => {
    if (!achivedLoading) {
      if (achivedData?.status === true) {
        if (createFlow === "bank") {
          setBankIsArchivedCurrent(true);
          dispatch(checkUsertoken());
          dispatch(
            beneBankLookUp({
              ifsc: payload?.ifsc_code,
              bank_account_no: payload?.bank_account,
            })
          );
          toast.success("Account archived successfully", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else if (createFlow === "pan") {
          setIsArchivedCurrent(true);
          dispatch(checkUsertoken());
          dispatch(beneLookUp({ pan_number: panNumber }));
          toast.success("Account archived successfully", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      } else if (achivedData?.status === false) {
        setIsArchivedCurrent(false);
        setBankIsArchivedCurrent(false);
        displayToastError(achivedData?.errors);
      }
    }
  }, [achivedData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        close(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [close]);

  useEffect(() => {
    if (!unachivedLoading) {
      if (unachivedData?.status === true) {
        if (createFlow === "bank") {
          setBankIsUnArchived(true);
          dispatch(checkUsertoken());
          dispatch(
            beneBankLookUp({
              ifsc: payload?.ifsc_code,
              bank_account_no: payload?.bank_account,
            })
          );
          toast.success("Account unarchived successfully", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else if (createFlow === "pan") {
          setIsUnArchived(true);
          dispatch(checkUsertoken());
          dispatch(beneLookUp({ pan_number: panNumber }));
          toast.success("Account unarchived successfully", {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      } else if (unachivedData?.status === false) {
        setIsUnArchived(false);
        setBankIsUnArchived(false);
        displayToastError(unachivedData?.errors);
      }
    }
  }, [unachivedData]);

  const handleConfirm = async () => {
    setIsButtonDisabled(true);
    try {
      if (createFlow === "bank") {
        await handlebank(); // Wait for handlebank() to complete
        setBankAccountType({ type: "", id: "" });
      } else if (createFlow === "pan") {
        await handlePan();
        setAccountType({ type: "", id: "" });
      }
      close(false);
      setShowAction(false);
    } catch (error) {
    } finally {
      dispatch(resetAchivedAccount());
      dispatch(resetUnAchivedAccount());
      setIsButtonDisabled(false); // Re-enable the button regardless of success or failure
    }
  };

  return (
    <>
      <div
        className="fixed w-screen top-0 left-0 h-screen z-[9998] "
        style={{ backgroundColor: "#000000", opacity: "0.8" }}
      ></div>
      <div
        className="flex justify-center items-center m-auto top-1/2 left-1/2 fixed z-[9999] p-3"
        style={{ transform: "translate(-50%, -50%)" }}
      >
        <div
          ref={modalRef}
          className="h-fit w-70% flex flex-col gap-2 px-[20px] pb-[20px] pt-[12px] bg-custom-appBackLight rounded-2xl"
          style={{
            width: isMobileView1 ? "350px" : "485px",
            maxWidth: "600px",
          }}
        >
          <div className="">
            <h6 className="text-custom-orange font-semibold font-sans text-Font_20">
              {title}
            </h6>
            <div className="flex items-center pb-[4px]"></div>
            <div className="">
              <p
                className="mb-[20px] text-Primary_white text-Font_16 font-normal font-sans"
                style={{ wordWrap: "break-word" }}
              >
                {message}
              </p>
              <p className="text-Font_16 font-normal font-sans text-Primary_grey mb-[20px]">
                Note - {note}
              </p>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "6%",
                // margin: "0px 50px",
                width: "100%",
              }}
              className="mt-[20px]"
            >
              <Button
                onClick={() => {
                  close(false);
                }}
                sx={{
                  borderColor: "none",
                  color: "var(--Primary_white)",
                  fontSize: "var(--Font_12)",
                  fontWeight: "var(--Font_normal)",
                  fontFamily: "Open Sans",
                  textTransform: "capitalize",
                  textDecoration: "underline",
                }}
              >
                Cancel
              </Button>
              <Button
                disabled={isButtonDisabled}
                sx={{
                  borderRadius: "20px",
                  color: "var(--Primary_white) !important",
                  fontSize: "var(--Font_12)",
                  fontWeight: "var(--Font_semibold)",
                  fontFamily: "Open Sans",
                  textTransform: "capitalize",
                  backgroundColor: "var(--Button_green)",

                  "&:hover": {
                    backgroundColor: "var(--Button_green_hover)",
                  },
                  // marginRight: "30px",
                  width: "79px",
                  height: "32px",
                }}
                onClick={handleConfirm}
              >
                {type === "unarchived" ? "Unarchive" : "Archive"}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BeneficiaryModal;
